import MechanicsAndWorkload from './MechanicsAndWorkload';

export default MechanicsAndWorkload;
